import React, { useMemo, useState } from 'react';
import { Button, Col, Container, Row } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useRouter } from 'next/router';
import { useAppContext } from '../../context/shared';
import { type GiftCardData } from '../../lib/types';
import { addToCartRequest } from '../../store/actions/cart';
import styles from '../../styles/GiftCards.module.css';
import { clickedCTA } from '../../store/actions/events';
import { ctaClickSources } from '../../lib/constants';
import { convergeTracking } from '../../lib/utils/converge';
import GiftCardOption from './GiftCardOption';

export function GiftCardItem(props: {
  readonly giftCard: GiftCardData;
  readonly disabled: boolean;
}) {
  const { giftCard } = props;
  const { localization } = useAppContext();
  const dispatch = useDispatch();
  const router = useRouter();
  const [selectedOption, setSelectedOption] = useState(
    Object.keys(giftCard.variantsJson)[0]
  );
  const handleSubmit = () => {
    dispatch(
      clickedCTA({
        name: ctaClickSources.giftCardSection.addToCart.name,
        url: router.asPath,
        variantId: giftCard.variantsJson[selectedOption].id,
        shopifyId: giftCard.shopifyId,
      })
    );
    convergeTracking.trackAddedToCartGiftCard(giftCard, selectedOption);
    dispatch(
      addToCartRequest({ id: giftCard.variantsJson[selectedOption].id })
    );
  };

  const sortedOptions = useMemo(() => {
    return Object.keys(giftCard.variantsJson).sort((a, b) =>
      Number.parseInt(giftCard.variantsJson[a].price) >
      Number.parseInt(giftCard.variantsJson[b].price)
        ? 1
        : -1
    );
  }, [giftCard]);

  return (
    <Container>
      <Row className="py-5">
        <Col sm="12" md="6" className="pe-5 mb-5 align-self-center">
          <img
            src={giftCard.shopifyImageUrl}
            className="img-fluid"
            alt="giftcard"
          />
        </Col>
        <Col sm="12" md="6" className="align-self-center">
          <div className={styles.optionsTitle}>
            {localization.gift_cards_options_title}
          </div>
          <div className={styles.giftCardOptions}>
            {sortedOptions.map((option) => (
              <GiftCardOption
                key={giftCard.variantsJson[option].id}
                price={giftCard.variantsJson[option].price}
                active={selectedOption === option}
                onClick={() => {
                  setSelectedOption(option);
                }}
              />
            ))}
          </div>

          <Button
            size="lg"
            className="w-100 mb-2"
            disabled={props.disabled}
            onClick={handleSubmit}
          >
            {localization.gift_cards_add_to_cart_btn}
          </Button>
          <div className="caption text-muted">{giftCard.description}</div>
        </Col>
      </Row>
    </Container>
  );
}
